<template lang="pug">
  div
    span(v-html='text')
</template>

<script>

exports.default = {
  props: {
    item: { required: true },
    searchText: { required: true }
  },

  methods: {
    replacer(match) {
      return `<strong>${match}</strong>`
    }
  },


  computed: {
    text() {
      function __guard__(value, transform) {
        return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
      }
      return __guard__(this.item != null ? this.item.name : undefined, x => x.replace(new RegExp(this.searchText, "i"), this.replacer))
    }
  }
}

</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// group_item.vue?39ab5586